import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { confirmSignUp, resendSignUpCode } from "@aws-amplify/auth";

const VerifyAcc = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(""); // Capture email for verification
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Handle verification
  const handleVerify = async () => {
    if (!email || !verificationCode) {
      setError("Please enter your email and verification code.");
      return;
    }

    setError("");
    setSuccess("");

    try {
      await confirmSignUp(email, verificationCode);
      setSuccess("Verification successful! Redirecting to login...");
      setTimeout(() => navigate("/login"), 2000); // Redirect after success
    } catch (err) {
      setError(err.message || "Verification failed. Please try again.");
    }
  };

  // Handle resend verification code
  const handleResendCode = async () => {
    if (!email) {
      setError("Please enter your email to resend the code.");
      return;
    }

    setError("");
    setSuccess("");

    try {
      await resendSignUpCode(email);
      setSuccess("Verification code resent! Check your email.");
    } catch (err) {
      setError(err.message || "Failed to resend code. Try again.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#1C1C1C] text-white px-6">
      
      {/* Back Button */}
      <button 
        onClick={() => navigate(-1)} 
        className="absolute top-6 left-6 text-[#CBDF52] flex items-center">
        <span className="text-lg">← Back</span>
      </button>

      {/* Verification Container */}
      <div className="bg-[#2F2D2D] w-[500px] h-auto rounded-lg flex flex-col items-center justify-center p-8">
        
        {/* Header */}
        <h1 className="font-[Montserrat] font-bold text-[32px] text-white text-center">
          Enter Verification Code
        </h1>

        <p className="text-white text-center mt-2">
          A verification code has been sent to your email.
        </p>

        {/* Email Input */}
        <div className="mt-6 w-full max-w-[300px]">
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full h-[45px] px-4 py-2 rounded-lg border border-gray-500 bg-[#2F2F2F] 
            text-white placeholder-gray-400 focus:border-[#CBDF52] focus:outline-none"
            placeholder="Enter your email"
          />
        </div>

        {/* Verification Code Input */}
        <div className="mt-4 w-full max-w-[300px]">
          <input 
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            className="w-full h-[45px] px-4 py-2 rounded-lg border border-gray-500 bg-[#2F2F2F] 
            text-white placeholder-gray-400 focus:border-[#CBDF52] focus:outline-none"
            placeholder="Enter code"
          />
        </div>

        {/* Error / Success Messages */}
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        {success && <p className="text-green-500 text-sm mt-2">{success}</p>}

        {/* Verify Button */}
        <button
          onClick={handleVerify}
          className="mt-6 w-[300px] h-[45px] rounded-lg bg-[#CBDF52] text-black font-semibold text-lg 
          hover:bg-[#B0C947] transition duration-300">
          Verify
        </button>

        {/* Resend Code Link */}
        <p className="text-white text-sm mt-4">
          Didn’t receive the verification code?{" "}
          <span 
            className="text-[#65DEF6] cursor-pointer hover:underline"
            onClick={handleResendCode}
          >
            Click to resend
          </span>
        </p>
        {/* Dog Image (Bottom Right) */}
        <img 
        src="/assets/images/puppy-2.png" 
        alt="Dog Illustration" 
        className="absolute w-[230.63px] h-[190.79px] bottom-[50px] right-[50px]"
      />
      </div>
    </div>
  );
};

export default VerifyAcc;
